import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import {createRequestOption, createRequestBody} from '../../shared/util';
import {environment} from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { Account } from 'src/app/core';

type EntityResponseType = HttpResponse<any>;
type EntityArrayResponseType = HttpResponse<any[]>;

@Injectable({ providedIn: 'root' })
export class UsersService {
  public resourceUrl = environment.SERVER_API_URL;

  constructor(protected http: HttpClient) {}

  create(product: any): Observable<EntityResponseType> {
    return this.http.post<any>(this.resourceUrl, product, { observe: 'response' });
  }
  createAdmin(product: any): Observable<EntityResponseType> {
    return this.http.post<any>(this.resourceUrl + 'api/admin/', product, { observe: 'response' });
  }
  update(product: any): Observable<EntityResponseType> {
    return this.http.put<any>(this.resourceUrl, product, { observe: 'response' });
  }
  updateAdmin(product: any): Observable<EntityResponseType> {
    return this.http.put<any>(this.resourceUrl + 'api/admin/' + product.id, product, { observe: 'response' });
  }
  deactivate(id: number): Observable<EntityResponseType> {
    const status = 'CANCELLED';
    return this.http.get(`${this.resourceUrl}/${id}/changeStatus/${status}`, { observe: 'response' });
  }

  find(id: number) {
    return this.http.get<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }
  findAdmin(id: number) {
    return this.http.get<any>(`${this.resourceUrl}api/admin/${id}`, { observe: 'response' });
  }
  findSale(id: number) {
    return this.http.get<any>(`${this.resourceUrl}api/crm/admin/${id}`, { observe: 'response' });
  }
  findCustomer(id: number) {
    return this.http.get<any>(`${this.resourceUrl}api/user/${id}`, { observe: 'response' });
  }
  findIssuer(id: number) {
    return this.http.get<any>(`${this.resourceUrl}api/product-issuer/${id}`, { observe: 'response' });
  }
  queryAdminGroup() {
    return this.http.get<any>(`${environment.SERVER_API_URL}/api/adminGroup/`, { observe: 'response' });
  }
  queryUsers(req){
    const options = createRequestBody(req);
    return this.http.post<any[]>(this.resourceUrl + 'api/user/list/', options , { observe: 'response' });
  }
  queryInvestors(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<any[]>(this.resourceUrl + 'investor', { params: options, observe: 'response' });
  }
  queryIssuers(req?: any){
    const options = createRequestOption(req);
    return this.http.get<any[]>(this.resourceUrl + 'api/product-issuer/list', { params: options});
  }
  queryAdmin(req?: any) {
    const options = createRequestOption(req);
    return this.http.get<any[]>(`${this.resourceUrl}api/admin/`, { observe: 'response' })
    .pipe(map((res: any) => {
      const result = res.body.data;
      return result;
    }));
  }
  queryCustomer(req?: any) {
    const body = createRequestBody(req);
    return this.http.post<any[]>(`${this.resourceUrl}api/user/list/`, body, { observe: 'response' })
    .pipe(map((res: any) => {
      const result = res.body.data;
      return result;
    }));
  }
  querySale(req?: any) {
    const options = createRequestOption(req);
    return this.http.get<any[]>(`${this.resourceUrl}api/crm/admin/`, { observe: 'response' })
    .pipe(map((res: any) => {
      const result = res.body.data;
      return result;
    }));
  }
  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<any[]>(this.resourceUrl, { params: options, observe: 'response' });
  }

  delete(id: number): Observable<HttpResponse<{}>> {
    return this.http.delete(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }
  deleteAdmin(id: number): Observable<HttpResponse<{}>> {
    return this.http.delete(`${this.resourceUrl}api/admin/${id}`, { observe: 'response' });
  }
  changeStatusInvestor(userId, statusId) {
    const body = { statusId};
    return this.http.patch<any[]>(this.resourceUrl + `api/user/status/${userId}`, body , { observe: 'response' });
  }
  lockInvestor(userId) {
    const body = { statusId: 3};
    return this.http.patch<any[]>(this.resourceUrl + `api/user/status/${userId}`, body , { observe: 'response' });
  }
  updateStatusCustomer(body: any) {
    return this.http.patch<any>(this.resourceUrl + 'api/user/status/' + body.id, body, { observe: 'response' });
  }
  updateCustomer(body: any) {
    return this.http.put<any>(this.resourceUrl + 'api/user/' + body.id, body, { observe: 'response' });
  }
  createIssuer(body) {
    return this.http.post(this.resourceUrl + `api/product-issuer/`, body);
  }
  updateIssuer(body) {
    return this.http.put(this.resourceUrl + `api/product-issuer/${body.id}`, body );
  }
  changeAvatarIssuer(body: any) {
    return this.http.post(environment.SERVER_API_URL +`api/product-issuer/${body.id}/change-avatar`, body, { observe: 'response' });
  }
  updateStatus(body: any) {
    return this.http.post<any>(environment.SERVER_API_URL +`api/product-issuer/${body.id}/change-status`, body, { observe: 'response' });
  }
  createSale(product: any): Observable<EntityResponseType> {
    return this.http.post<any>(this.resourceUrl + 'api/crm/admin/', product, { observe: 'response' });
  }
  updateSale(product: any): Observable<EntityResponseType> {
    return this.http.put<any>(this.resourceUrl + 'api/crm/admin/' + product.id, product, { observe: 'response' });
  }
 
  
}
